import { render } from "./ccAverageCOP.vue?vue&type=template&id=2efab294"
import script from "./ccAverageCOP.vue?vue&type=script&lang=js"
export * from "./ccAverageCOP.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Dev\\CCERWB\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__